import React, { useState } from 'react';
import {
  Colors,
  Divider,
  Flex,
  IconChevronDown,
  RemoteImage,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';

export const WashingGuide: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { width: screenWidth } = useScreenSize();

  return (
    <Flex>
      <Divider size="small" />
      <Flex padding={{ horizontal: 16 }}>
        <Flex.Row
          justifyContent={'space-between'}
          alignItems={'center'}
          padding={{ vertical: 20 }}
          onPress={() => setIsOpen(true)}
        >
          <Typography type={'h5'} color={'content_primary'}>
            WASHING GUIDE
          </Typography>
          {!isOpen && (
            <Flex.Center padding={{ horizontal: 8, vertical: 8 }}>
              <IconChevronDown size={16} fill={Colors.content_primary} />
            </Flex.Center>
          )}
        </Flex.Row>
      </Flex>
      <Divider size="small" />
      {isOpen && (
        <>
          <RemoteImage
            uri={'https://img.a-bly.com/manual/washing_guide_v2.webp'}
            width={screenWidth}
            height={screenWidth * (6882 / 1125)}
          />
          {/*<Image*/}
          {/*  source={require('../assets/img-washing.png')}*/}
          {/*  style={{ width: screenWidth, height: screenWidth * (5820 / 1080) }}*/}
          {/*  resizeMode="contain"*/}
          {/*/>*/}
          <Divider size="small" />
        </>
      )}
    </Flex>
  );
};
